export interface Creator {
  name: string;
  directory: string;
  type: "creator";
  displayName: string;
  thumbnail: string;
  icon: string;
  masterFile: string;
  masterVersionStr: "";
  isRootCategory: "";
  isDefaultAsset: "";
  isEnabled: true;
  isPublished: string;
  variation: string;
  attachedTo: string;
  children: object;
  attachmentMap: Record<string, string[]>;
  settings: CreatorSettings;
}

export interface Theme {
  id: string;
  name: string;
  displayName: string;
  description: string;
  isDefault: boolean;
  colors: ThemeColors;
  fonts: ThemeFonts;
  ui: ThemeUI;
}

export interface ThemeColors {
  primary: string;
  secondary: string;
  accent: string;
  background: string;
  surface: string;
  text: {
    primary: string;
    secondary: string;
    disabled: string;
  };
  error: string;
  warning: string;
  success: string;
  info: string;
}

export interface ThemeFonts {
  primary: string;
  secondary: string;
  heading: string;
  body: string;
  mono: string;
  sizes: {
    xs: string;
    sm: string;
    base: string;
    lg: string;
    xl: string;
    "2xl": string;
    "3xl": string;
  };
}

export interface ThemeUI {
  borderRadius: {
    sm: string;
    md: string;
    lg: string;
    xl: string;
  };
  shadows: {
    sm: string;
    md: string;
    lg: string;
    xl: string;
  };
  spacing: {
    xs: string;
    sm: string;
    md: string;
    lg: string;
    xl: string;
  };
}

export interface CreatorSettings {
  theme?: string;
  background?: string;
  charLandingMode?: boolean;
}

// Menu building types

export const CREATOR_DATA_TYPES = {
  ATTACHMENT: "attachment",
  GEOMETRY: "geometry",
  MODEL: "model",
  GROUP: "group",
  CHARACTER: "character",
  SET: "set",
  SETS: "sets",
  ASSET_LIB: "assetLib"
} as const;

export type CreatorOptionType =
  (typeof CREATOR_DATA_TYPES)[keyof typeof CREATOR_DATA_TYPES];

export interface CreatorOptionNode {
  key: string;
  name: string;
  displayName: string;
  path?: string;
  type: CreatorOptionType;
  icon?: string;
  thumbnail?: string;
  displayAsset?: boolean;
  defaultAsset?: string;
  isEnabled: boolean;
  isRootCategory: boolean;
  children?: Record<string, CreatorOptionNode>;
  parentKey: string;
  parentDisplayName: string;
  directory?: string;
  attachmentData?: object;
  modelVariations: Record<string, string>;
  modelVariationsIcons: Record<string, string>;
  slot?: string;
  attachmentDirectory?: string;
  baseScale?: number;
  scaleRatio?: number;
  overrideSlots?: string[];
  defaultVariation?: string;
  isVisible?: boolean;
  isEditable?: boolean;
  isPublished?: boolean;
  characterStats?: Record<string, string>;
  isFlipIcon: boolean;
  spacing?: number;
  spaceValue?: number;
  pairedAttachment: string;
  isMandatoryAttachment: boolean;
}

export interface StoreAssetPairData {
  assetPair: string;
  url: string;
}

export interface VariationData {
  name: string;
  parentKey: string;
  path: string;
  key: string;
  icon?: string;
  isSelected?: boolean;
}

export interface CreatorPriceData {
  variantBaseSize: number;
  price: number;
  variantMedium: string;
  title: string;
}

export interface StatsData {
  index: number;
  name?: string;
  type: string;
  range: number[];
  division: number;
  icon: string;
  suffix?: string;
  value: string;
}

export const StatsDataType = {
  INTEGER: "integer",
  ADDATIVE: "addativeInteger",
  STRING: "string",
  STEP: "stepValue"
};
